module.exports = __webpack_public_path__ + "static/media/rule_piece.56023172.svg";